import React from "react";
import { Link, useLocation } from "react-router-dom";
import desktopfooter from "../../assets/img/desktopfooter.png";
import footermobile from "../../assets/img/footermobile.png";
import logo from '../../assets/img/logo.png';
import { useScreenSize } from "provider/ScreenSizeProvider";
import { common } from "Data/common";

const Footer = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const lastSegment = pathSegments[pathSegments.length - 1];
  const { isMobileView } = useScreenSize();

  //hide on chat
  if (lastSegment == 'chat') return

  return (
    <>
      {!isMobileView && (<footer
        className="main_footer position-relative"
      >
        <div className="footer_object">
          <img src={desktopfooter} alt="" className="d-md-block d-none" />
          <img src={footermobile} alt="" className="d-md-none d-block" />
        </div>
        <div className="container-fluid">
          <div className="row justify-content-between border_bottom px-lg-5">
            <div className="col-lg-4">
              <div className="footer_text">
                <div className="heading-footer">
                  <h6>{common?.FOOTER?.ABOUT?.TITLE}</h6>
                </div>
                <div className="footerContent">
                  <div
                    className="content_terms"
                    style={{ overflowWrap: "break-word" }}
                  >
                    <p>
                      {common?.FOOTER?.ABOUT?.TEXT_1}
                    </p>

                    <p>
                      {common?.FOOTER?.ABOUT?.TEXT_2}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-2 Col-md-6">
              <div className="footer_text float-lg-end">
                <div className="heading-footer">
                  <h6> {common?.FOOTER?.POLICY?.TITLE} </h6>
                </div>
                <div className="footerContent">
                  <ul className="footer_listing">
                    <li>
                      <Link to="/privacy-policy"> {common?.FOOTER?.POLICY?.PRIVACY_POLICY} </Link>
                    </li>
                    <li>
                      <Link to="/terms-of-use"> {common?.FOOTER?.POLICY?.TERMS_CONDITIONS} </Link>
                    </li>
                    <li>
                      <Link to="/refund-and-cancellation-policy"> {common?.FOOTER?.POLICY?.REFUND_POLICY} </Link>
                    </li>
                     {/*<li>
                      <Link to="cancellation"> Cancellation Policy </Link>
                    {/* <li>
                      <Link to="cancellation"> {common?.CANCELLATION_POLICY} </Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer_text float-lg-end">
                <div className="heading-footer">
                  <h6> {common?.FOOTER?.LINKS?.TITLE} </h6>
                </div>
                <div className="footerContent">
                  <ul className="footer_listing">
                    {/* <li>
                      <Link to="/article">{common.ARTICLES_TIPS}</Link>
                    </li> */}
                    <li>
                      <Link to="/about-us">{common?.FOOTER?.LINKS?.ABOUT_US}</Link>
                    </li>
                    <li>
                      <Link to="/contact-us">{common?.FOOTER?.LINKS?.CONTACT_US}</Link>
                    </li>
                    <li>
                      <Link to="/faq">{common?.FOOTER?.LINKS?.FAQS}</Link>
                    </li>
                    {/* <li>
                      <Link to="/icicipayment">ICICI</Link>
                    </li> */}
                    {/* <li>
                      <Link to="/payu">PayU</Link>
                    </li> */}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footer_text float-lg-end">
                <div className="heading-footer">
                  <h6>{common?.FOOTER?.CONTACT_INFO?.TITLE}</h6>
                </div>
                <div className="footerContent">
                  <p>
                    <strong>{common?.FOOTER?.CONTACT_INFO?.ADDRESS_LABEL}:</strong> {common?.FOOTER?.CONTACT_INFO?.ADDRESS}
                  </p>
                  <p>
                    <strong>{common?.FOOTER?.CONTACT_INFO?.EMAIL_LABEL}:</strong>{" "}
                    <a href={common?.FOOTER?.SOCIAL?.EMAIL}>
                      {common?.FOOTER?.CONTACT_INFO?.EMAIL}
                    </a>
                  </p>
                  <div className="d-flex align-items-center gap-2">
                    <div className="insticon">
                      <i className="fa-brands fa-instagram"></i>
                    </div>

                    <Link
                      to={common?.FOOTER?.SOCIAL?.INSTAGRAM}
                      target="_blank"
                    >
                      {common?.FOOTER?.CONTACT_INFO?.WEBSITE}
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-4 justify-content-between mobile-responsive align-items-center">
            <div className="col-lg-2 col-xxl-2 ">
              <div className="footerlogo">
                <img src={logo} alt="" width="160" />
              </div>
            </div>
            <div className="col-lg-6 col-xxl-7 ">
              <div className="copyright text-center">
                <p className="text-capitalize">
                  {common?.FOOTER?.CONTACT_INFO?.DEVELOPED_BY}
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-xxl-3 ">
              <div className="d-flex gap-3  justify-content-lg-end justify-content-center">
                <div className="terms">
                  <p className="mb-0  pt-0">
                    {common?.FOOTER?.CONTACT_INFO?.COPYRIGHT}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      )}
    </>
  );
};

export default Footer;
